import { Col, Form, Row, Select } from "antd";
import styled from "styled-components";
import { CONSENT_FIELDS } from "components/consentTag/consentConstants";

const StyledSelect = styled(Select)`
  max-width: 400px !important;
  margin-right: 4px;
`;

const CONSENT_VALUE_OPTIONS = [
  { label: "Consent", value: "consent" },
  { label: "No Consent", value: "no_consent" },
  { label: "Unknown", value: "unknown" },
];

export default function DebtorConsentSubForm() {
  return (
    <>
      {CONSENT_FIELDS.map((field) => (
        <Row align="middle" gutter={12} key={field.name}>
          <Col span={12}>
            <Form.Item name={["operations", "updateDebtorConsent", field.name]} label={field.label}>
              <StyledSelect allowClear options={CONSENT_VALUE_OPTIONS} placeholder="No change" />
            </Form.Item>
          </Col>
        </Row>
      ))}
    </>
  );
}
